/* eslint react/prop-types: 0 */
import { FormInput } from 'camino-react'
import React from 'react'
import Select from 'react-select'

const SetPriorityAction = ({
  update,
  operations: { priority_id: priorityID }
}) => {
  const options = [
    { label: 1, value: 1 },
    { label: 2, value: 2 },
    { label: 3, value: 3 },
    { label: 4, value: 4 },
    { label: 5, value: 5 }
  ]

  return (
    <FormInput label="Priority">
      <Select
        onChange={e => update('priority_id', e.value)}
        options={options}
        value={priorityID}
      />
    </FormInput>
  )
}

export default SetPriorityAction
